import FrenchBase from '../i18n/messages/fr.json';
import EnglishBase from '../i18n/messages/en.json';
import adminEn from '../components/language/admin.en.json';
import adminFr from '../components/language/admin.fr.json';

const English = { ...EnglishBase, ...adminEn };
const French = { ...FrenchBase, ...adminFr };

export {
    English,
    French
}
